// @flow
export const API_BASE: string = process.env.REACT_APP_API
  ? process.env.REACT_APP_API
  : 'https://livecms.roymorgandev.com';
